import React from 'react';
import { Button } from '@cityelectricalfactors/ui-components';
import { CrossIcon } from '../../../assets/common_svgs';

const QuickOrdersRemoveIcon = ({ action, cn, height, width, disabled }) => (
  <Button
    className="quick-orders__hidden-button"
    label="Remove order"
    disabled={disabled}
    handleClick={() => action()}>
    <CrossIcon cn={cn} fillColor="#60686C" height={height} width={width} />
  </Button>
);

export default QuickOrdersRemoveIcon;
